import React from 'react';
import { RatingStars } from './ui/RatingStars';
import { Check } from 'lucide-react';
interface ReviewCategoryProps {
  title: string;
  rating: number;
  description?: string;
  points: string[];
}
export function ReviewCategory({
  title,
  rating,
  description,
  points
}: ReviewCategoryProps) {
  return <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8 hover:shadow-md transition-shadow duration-300" data-id="element-89">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-2" data-id="element-90">
        <h3 className="text-xl font-bold text-slate-900" data-id="element-91">{title}</h3>
        <div className="flex items-center bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-100" data-id="element-92">
          <span className="font-bold text-slate-900 mr-2" data-id="element-93">
            {rating.toFixed(1)}
          </span>
          <RatingStars rating={rating} size="sm" data-id="element-94" />
        </div>
      </div>

      {description && <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-95">{description}</p>}

      <ul className="space-y-3" data-id="element-96">
        {points.map((point, index) => <li key={index} className="flex items-start" data-id="element-97">
            <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-98" />
            <span className="text-slate-700 text-sm md:text-base" data-id="element-99">{point}</span>
          </li>)}
      </ul>
    </div>;
}